export const environment = {
  production: false,
  // apiBase: 'http://127.0.0.1:8000',
  apiBase: 'https://cshapps-api.mavenepm.com',
  apiVersion: 'v1',
  xApiToken: '94b0c32252a482ab9dcc9dd1b952abc1',
  appName: 'Admin Control',
  appVersion: '3.0.1',
  role: 'admin',
};
